import { Box, styled, Typography, IconButton } from "@mui/material"
import React from "react"

const StyledContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: '16px',
  borderBottom: '1px solid var(--Interviewer-Near-White)',
  [theme.breakpoints.up('md')]: {
    padding: '32px',
  }
}));

interface AdminPageHeaderProps {
    title?: string
    children?: React.ReactNode
    icon?: React.ReactNode
    onIconClick?: () => void
}

const HeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const AdminPageHeader = ({title, children, icon, onIconClick}: AdminPageHeaderProps) => {
    return (
        <StyledContainer>
            <HeaderRow>
              {icon && (
                onIconClick ? (
                  <IconButton onClick={onIconClick}>{icon}</IconButton>
                ) : (
                  <Box sx={{display: 'flex', alignItems: 'center'}}>{icon}</Box>
                )
              )}
              <Typography variant="h1">
                  {title}
              </Typography>
            </HeaderRow>
            {children}
        </StyledContainer>
    )
}
export default AdminPageHeader